@if (isLoading) {
  <div class="inventory-item-tab__spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

@if (viewModel$ | async; as vm) {
  <div class="inventory-item-finances-tab" [formGroup]="overviewForm.form">
    @if (vm.previewFieldLabelKey) {
      <p class="inventory-item-finances-tab__notice">
        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.PREVIEW_UPDATED' | translate: { field: (vm.previewFieldLabelKey | translate) } }}
      </p>
    }

    <div class="inventory-item-finances-tab__grid">
      <app-dynamic-editable-field
        class="inventory-item-finances-tab__field"
        [formControlName]="vm.salesPriceField.controlName"
        layout="stacked"
        inputType="number"
        inputClass="inventory-item-finances-tab__input"
        (updatedInput)="onPreviewFieldUpdate(vm.salesPriceField.controlName)"
      >
        <ng-template #labelTpl>
          <div class="inventory-item-finances-tab__field-label form-label required">
            {{ vm.salesPriceField.label | translate }}
          </div>
        </ng-template>
        <ng-template #contentTpl>
          <div [class]="vm.salesPriceField.valueClass">
            {{ vm.salesPriceField.value }}
          </div>
        </ng-template>
      </app-dynamic-editable-field>

      <app-dynamic-editable-field
        class="inventory-item-finances-tab__field"
        [formControlName]="vm.costField.controlName"
        layout="stacked"
        inputType="number"
        inputClass="inventory-item-finances-tab__input"
        (updatedInput)="onPreviewFieldUpdate(vm.costField.controlName)"
      >
        <ng-template #labelTpl>
          <div class="inventory-item-finances-tab__field-label form-label required">
            {{ vm.costField.label | translate }}
          </div>
        </ng-template>
        <ng-template #contentTpl>
          <div [class]="vm.costField.valueClass">
            {{ vm.costField.value }}
          </div>
        </ng-template>
      </app-dynamic-editable-field>

      <div class="inventory-item-finances-tab__field inventory-item-finances-tab__field--readonly">
        <div class="inventory-item-finances-tab__field-label">
          {{ vm.marginDisplay.label | translate }}
        </div>
        <div class="inventory-item-finances-tab__field-value">
          <span [class]="vm.marginDisplay.percentageClass">
            {{ vm.marginDisplay.percentage }}
          </span>
          <span class="inventory-item-finances-tab__margin-amount">
            ({{ vm.marginDisplay.amount }})
          </span>
        </div>
      </div>

      <app-dynamic-editable-field
        class="inventory-item-finances-tab__field"
        [formControlName]="vm.currencyField.controlName"
        layout="stacked"
        inputType="select"
        inputClass="inventory-item-finances-tab__input"
        [enumName]="vm.currencyField.enumName ?? ''"
        [enumObject]="vm.currencyField.enumObject"
        [selectItems]="vm.currencyField.selectItems"
        (updatedInput)="onPreviewFieldUpdate(vm.currencyField.controlName)"
      >
        <ng-template #labelTpl>
          <div class="inventory-item-finances-tab__field-label form-label required">
            {{ vm.currencyField.label | translate }}
          </div>
        </ng-template>
        <ng-template #contentTpl>
          <div [class]="vm.currencyField.valueClass">
            {{ vm.currencyField.valueKey! | translate }}
          </div>
        </ng-template>
      </app-dynamic-editable-field>

      <app-dynamic-editable-field
        class="inventory-item-finances-tab__field inventory-item-finances-tab__field--wide"
        [formControlName]="vm.priceIncludesVatField.controlName"
        layout="stacked"
        [stretchLabelRow]="true"
        inputType="custom"
        (updatedInput)="onPreviewFieldUpdate(vm.priceIncludesVatField.controlName)"
      >
        <ng-template #labelTpl>
          <label class="inventory-item-finances-tab__checkbox-shell inventory-item-finances-tab__checkbox-shell--readonly">
            <input
              type="checkbox"
              class="inventory-item-finances-tab__checkbox-control h-4 w-4"
              [checked]="vm.priceIncludesVatField.booleanValue"
              disabled
            />
            <span class="inventory-item-finances-tab__checkbox-label">
              {{ 'COMPONENTS.GOODS.FIELDS.PRICE_INCLUDES_TAX' | translate }}
            </span>
          </label>
        </ng-template>
        <ng-template #inputTpl let-value="value" let-update="update">
          <label class="inventory-item-finances-tab__checkbox-shell inventory-item-finances-tab__checkbox-shell--editor">
            <input
              type="checkbox"
              class="inventory-item-finances-tab__checkbox-control h-4 w-4"
              [checked]="value"
              (change)="update($any($event.target).checked)"
            />
            <span class="inventory-item-finances-tab__checkbox-label">
              {{ 'COMPONENTS.GOODS.FIELDS.PRICE_INCLUDES_TAX' | translate }}
            </span>
          </label>
        </ng-template>
      </app-dynamic-editable-field>
    </div>
  </div>
}
